export enum ActionsAccount {
	ERROR_ACCOUNT = 'ERROR_ACCOUNT',
	FETCH_ACCOUNT = 'FETCH_ACCOUNT',
	FETCH_ACCOUNTS = 'FETCH_ACCOUNTS',
	REQUEST_ACCOUNT = 'REQUEST_ACCOUNT',
	CREATE_ACCOUNT = 'CREATE_ACCOUNT',
	STATUS_REQUEST_ACCOUNT = 'STATUS_REQUEST_ACCOUNT',
	CLEAN_CURRENT_ACCOUNT = 'CLEAN_CURRENT_ACCOUNT',
	CLEAN_STATUS_ACCOUNT = 'CLEAN_STATUS_ACCOUNT',
	DELETE_ACCOUNT = 'DELETE_ACCOUNT',
	CHANGE_STATUS_ACCOUNT = 'CHANGE_STATUS_ACCOUNT'
}


export enum EStatusAccountRequest {
	PENDING,
	PROCESS,
	COMPLETE,
	FAIL
}
